"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultTranslations = exports.AllowedTypes = void 0;
// CustomFileUploader.tsx
var react_1 = __importStar(require("react"));
var react_toastify_1 = require("react-toastify");
var fa_1 = require("react-icons/fa");
// ====================
// Tip Tanımlamaları
// ====================
var AllowedTypes;
(function (AllowedTypes) {
    AllowedTypes["PDF"] = "pdf";
    AllowedTypes["FILE"] = "file";
    AllowedTypes["IMAGE"] = "image";
    AllowedTypes["VIDEO"] = "video";
    AllowedTypes["VISUAL"] = "visual";
    AllowedTypes["ALL"] = "all";
})(AllowedTypes = exports.AllowedTypes || (exports.AllowedTypes = {}));
exports.defaultTranslations = {
    dropAreaText: "Dosyaları buraya sürükleyip bırakın veya tıklayarak dosya seçin.",
    fileLimitMultiText: "Maksimum dosya limiti",
    fileLimitSingleText: "Tek dosya seçilebilir",
    uploadButtonText: "Yükle",
    removeButtonTitle: "Kaldır",
    uploadSuccessToast: "Dosyalar başarıyla yüklendi.",
    uploadErrorToast: "Dosyalar yüklenirken bir hata oluştu.",
    uploadWarningLimit: "Dosya yükleme limitini doldurdunuz. Yeni dosya ekleyebilmek için mevcut dosyaları kaldırın.",
    uploadWarningExceed: "Seçilen dosya sayısı limiti aştı. Eklenebilecek dosya sayısı: ",
    fileSizeError: "isimli dosya, boyut limitini aşıyor.",
    fileTypeError: "isimli dosya, seçilen dosya türüne uygun değil.",
    noFileSelectedWarning: "Önce en az bir dosya seçiniz."
};
// ====================
// Stil Ayarları
// ====================
var dropAreaStyle = {
    border: "2px dashed #007bff",
    borderRadius: "5px",
    padding: "20px",
    textAlign: "center",
    cursor: "pointer",
    position: "relative",
    minHeight: "150px",
};
var previewContainerStyle = {
    display: "flex",
    flexWrap: "wrap",
    gap: "10px",
    justifyContent: "center",
};
var previewItemStyle = {
    position: "relative",
    width: "100px",
    height: "100px",
    border: "1px solid #ccc",
    overflow: "hidden",
};
var removeButtonStyle = {
    position: "absolute",
    top: "2px",
    right: "2px",
    background: "rgba(255,255,255,0.7)",
    border: "none",
    cursor: "pointer",
    borderRadius: "50%",
    zIndex: 2,
};
var tickOverlayStyle = {
    position: "absolute",
    bottom: "2px",
    right: "2px",
    backgroundColor: "rgba(0, 128, 0, 0.7)",
    color: "white",
    borderRadius: "50%",
    width: "24px",
    height: "24px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    zIndex: 2,
};
// Dosya ikonları
var fileTypeIcons = {
    ".doc": react_1.default.createElement(fa_1.FaFileWord, null),
    ".docx": react_1.default.createElement(fa_1.FaFileWord, null),
    ".xls": react_1.default.createElement(fa_1.FaFileExcel, null),
    ".xlsx": react_1.default.createElement(fa_1.FaFileExcel, null),
    ".pdf": react_1.default.createElement(fa_1.FaFilePdf, null),
    ".txt": react_1.default.createElement(fa_1.FaFilePdf, null),
};
var defaultFileIcon = react_1.default.createElement(fa_1.FaFile, null);
// İzin verilen dosya uzantıları
var allowedFileExtensions = [".pdf", ".doc", ".docx", ".xls", ".xlsx", ".txt"];
var allowedImageExtensions = [".jpg", ".jpeg", ".png", ".gif", ".bmp", ".webp"];
var allowedVideoExtensions = [".mp4", ".avi", ".mov", ".mkv", ".webm", ".flv"];
// ====================
// Yardımcı Fonksiyonlar
// ====================
var getFileExtension = function (file) {
    var dotIndex = file.name.lastIndexOf(".");
    return dotIndex !== -1 ? file.name.substring(dotIndex).toLowerCase() : "";
};
var isImageFile = function (file) {
    return allowedImageExtensions.includes(getFileExtension(file));
};
var isAllowedFileType = function (file, allowedType) {
    var ext = getFileExtension(file);
    switch (allowedType) {
        case AllowedTypes.ALL:
            return true;
        case AllowedTypes.PDF:
            return ext === ".pdf";
        case AllowedTypes.FILE:
            return allowedFileExtensions.includes(ext);
        case AllowedTypes.IMAGE:
            return allowedImageExtensions.includes(ext);
        case AllowedTypes.VIDEO:
            return allowedVideoExtensions.includes(ext);
        case AllowedTypes.VISUAL:
            return allowedImageExtensions.includes(ext) || allowedVideoExtensions.includes(ext);
        default:
            return false;
    }
};
// ====================
// CustomFileUploader Bileşeni
// ====================
var CustomFileUploader = function (props) {
    var url = props.url, multi = props.multi, allowedTypes = props.allowedTypes, maxFile = props.maxFile, maxSize = props.maxSize, onUploadComplete = props.onUploadComplete, onRemoveUploaded = props.onRemoveUploaded, label = props.label, onPendingChange = props.onPendingChange, translations = props.translations;
    // Varsayılan çeviri metinlerini, gelen prop ile birleştiriyoruz.
    var finalTranslations = __assign(__assign({}, exports.defaultTranslations), translations);
    var _a = (0, react_1.useState)([]), previews = _a[0], setPreviews = _a[1];
    var fileInputRef = (0, react_1.useRef)(null);
    // Pending dosya sayısını parent'a iletecek yardımcı fonksiyon
    var updatePendingStatus = function (previewsArray) {
        if (onPendingChange) {
            var pendingFileCount = previewsArray.filter(function (item) { return !item.uploaded; }).length;
            onPendingChange(pendingFileCount);
        }
    };
    // Dosyaları ekleme işlemi
    var handleFiles = function (files) {
        var filesArray = Array.from(files);
        var currentCount = multi ? previews.length : (previews.length > 0 ? 1 : 0);
        var availableSlots = multi ? maxFile - currentCount : (currentCount === 0 ? 1 : 0);
        if (availableSlots <= 0) {
            react_toastify_1.toast.warning(finalTranslations.uploadWarningLimit);
            return;
        }
        var filesToAdd = filesArray.slice(0, availableSlots);
        if (filesArray.length > availableSlots) {
            react_toastify_1.toast.warning(finalTranslations.uploadWarningExceed + availableSlots);
        }
        var newPreviews = [];
        filesToAdd.forEach(function (file, index) {
            if (file.size > maxSize) {
                // Dosya adını eklemek için file.name'i dışarıda ekliyoruz.
                react_toastify_1.toast.error(file.name + " " + finalTranslations.fileSizeError);
                return;
            }
            if (!isAllowedFileType(file, allowedTypes)) {
                react_toastify_1.toast.error(file.name + " " + finalTranslations.fileTypeError);
                return;
            }
            var isImg = allowedTypes === AllowedTypes.IMAGE || (allowedTypes === AllowedTypes.VISUAL && isImageFile(file));
            var previewContent = isImg && isImageFile(file)
                ? URL.createObjectURL(file)
                : fileTypeIcons[getFileExtension(file)] || defaultFileIcon;
            newPreviews.push({
                id: "".concat(file.name, "_").concat(file.lastModified, "_").concat(Date.now(), "_").concat(index),
                file: file,
                isImage: isImg,
                previewContent: previewContent,
                uploaded: false,
            });
        });
        setPreviews(function (prev) {
            var updatedPreviews = __spreadArray(__spreadArray([], prev, true), newPreviews, true);
            updatePendingStatus(updatedPreviews);
            return updatedPreviews;
        });
    };
    // Dosya input değişiminde
    var handleFileChange = function (e) {
        if (e.target.files && e.target.files.length > 0) {
            handleFiles(e.target.files);
        }
    };
    // Drag & Drop olayları
    var handleDrop = function (e) {
        e.preventDefault();
        if (e.dataTransfer.files && e.dataTransfer.files.length > 0) {
            handleFiles(e.dataTransfer.files);
            e.dataTransfer.clearData();
        }
    };
    var handleDragOver = function (e) {
        e.preventDefault();
    };
    // Dosya seçim alanına tıklayınca input'u tetikleyin
    var handleAreaClick = function () {
        var _a;
        (_a = fileInputRef.current) === null || _a === void 0 ? void 0 : _a.click();
    };
    // Dosya kaldırma işlemi
    var handleRemoveFile = function (previewId) {
        var updatedPreviews = previews.filter(function (item) { return item.id !== previewId; });
        setPreviews(updatedPreviews);
        updatePendingStatus(updatedPreviews);
        var itemToRemove = previews.find(function (item) { return item.id === previewId; });
        if (itemToRemove && itemToRemove.uploaded && itemToRemove.serverFileName && onRemoveUploaded) {
            onRemoveUploaded(itemToRemove.serverFileName);
        }
    };
    // Dosyaları sunucuya yükleme işlemi
    var handleUpload = function () { return __awaiter(void 0, void 0, void 0, function () {
        var filesToUpload, formData, response, data, uploadedFileNames_1, errorData, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    filesToUpload = previews.filter(function (item) { return !item.uploaded; }).map(function (item) { return item.file; });
                    if (filesToUpload.length === 0) {
                        react_toastify_1.toast.warning(finalTranslations.noFileSelectedWarning);
                        return [2 /*return*/];
                    }
                    formData = new FormData();
                    filesToUpload.forEach(function (file) {
                        formData.append("file", file);
                    });
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 7, , 8]);
                    return [4 /*yield*/, fetch(url, {
                            method: "POST",
                            body: formData,
                        })];
                case 2:
                    response = _a.sent();
                    if (!response.ok) return [3 /*break*/, 4];
                    return [4 /*yield*/, response.json()];
                case 3:
                    data = _a.sent();
                    if (data.responseCode === 200 &&
                        data.content &&
                        data.content.fileList &&
                        data.content.fileList.length > 0) {
                        uploadedFileNames_1 = data.content.fileList.map(function (item) { return item.fileName; });
                        if (onUploadComplete) {
                            onUploadComplete(uploadedFileNames_1);
                        }
                        setPreviews(function (prev) {
                            var updatedPreviews = prev.map(function (item, index) {
                                if (!item.uploaded) {
                                    return __assign(__assign({}, item), { uploaded: true, serverFileName: uploadedFileNames_1[index] || item.file.name });
                                }
                                return item;
                            });
                            updatePendingStatus(updatedPreviews);
                            return updatedPreviews;
                        });
                        react_toastify_1.toast.success(finalTranslations.uploadSuccessToast);
                    }
                    else {
                        react_toastify_1.toast.error(finalTranslations.uploadErrorToast);
                    }
                    return [3 /*break*/, 6];
                case 4: return [4 /*yield*/, response.json()];
                case 5:
                    errorData = _a.sent();
                    console.error("API Hatası:", errorData);
                    react_toastify_1.toast.error(finalTranslations.uploadErrorToast);
                    _a.label = 6;
                case 6: return [3 /*break*/, 8];
                case 7:
                    error_1 = _a.sent();
                    console.error("API çağrısında hata:", error_1);
                    react_toastify_1.toast.error(finalTranslations.uploadErrorToast);
                    return [3 /*break*/, 8];
                case 8: return [2 /*return*/];
            }
        });
    }); };
    // Dosya seçme alanı için drop area metni: dropAreaText + dosya limiti bilgisi
    var dropAreaText = multi
        ? finalTranslations.dropAreaText + " (" + finalTranslations.fileLimitMultiText + ": " + maxFile + ") "
        : finalTranslations.dropAreaText + " " + (finalTranslations.fileLimitSingleText);
    return (react_1.default.createElement("div", { style: { width: "100%", height: "100%" } },
        label && (react_1.default.createElement("div", { style: { marginBottom: "10px" } },
            react_1.default.createElement("label", { style: { fontWeight: "bold" } }, label))),
        react_1.default.createElement("div", { style: dropAreaStyle, onDrop: handleDrop, onDragOver: handleDragOver, onClick: handleAreaClick }, previews.length === 0 ? (react_1.default.createElement("div", null, dropAreaText)) : (react_1.default.createElement("div", { style: previewContainerStyle }, previews.map(function (item) { return (react_1.default.createElement("div", { key: item.id, style: { display: "flex", flexDirection: "column", alignItems: "center" } },
            react_1.default.createElement("div", { style: previewItemStyle },
                item.isImage ? (react_1.default.createElement("img", { src: item.previewContent, alt: "\u00D6nizleme ".concat(item.id), style: {
                        width: "100%",
                        height: "100%",
                        objectFit: "cover",
                    } })) : (react_1.default.createElement("div", { style: {
                        width: "100%",
                        height: "100%",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        fontSize: "48px",
                    } }, item.previewContent)),
                react_1.default.createElement("button", { type: "button", style: removeButtonStyle, onClick: function (e) {
                        e.stopPropagation();
                        handleRemoveFile(item.id);
                    }, title: finalTranslations.removeButtonTitle }, "\u00D7"),
                item.uploaded && react_1.default.createElement("div", { style: tickOverlayStyle }, "\u2713")),
            react_1.default.createElement("div", { style: {
                    marginTop: "4px",
                    fontSize: "12px",
                    textAlign: "center",
                    maxWidth: "100px",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap",
                }, title: item.file.name }, item.file.name))); })))),
        react_1.default.createElement("input", { type: "file", multiple: multi, ref: fileInputRef, onChange: handleFileChange, style: { display: "none" } }),
        previews.filter(function (item) { return !item.uploaded; }).length > 0 && (react_1.default.createElement("div", { style: { marginTop: "10px", textAlign: "center" } },
            react_1.default.createElement("button", { type: "button", className: "btn btn-primary", onClick: handleUpload }, finalTranslations.uploadButtonText)))));
};
exports.default = CustomFileUploader;
